// extracted by mini-css-extract-plugin
export default {"UserBox":"Users_UserBox__osBpZ"};